define('toolkit/b-controls-group/b-controls-group', [
	  'jquery'
	, 'toolkit/b-toolkit/b-toolkit'
	, 'toolkit/b-dropdown/b-dropdown'
	, 'toolkit/b-controls-group-utils/b-controls-group-utils'
], function ($, toolkit) {
	'use strict';

	/**
	 * Селектор, который находит поля, в которе можно вводить
	 * текстовую информацию
	 * @type {string}
	 */
	var TEXTABLE_FIELD_SELECTOR = 	'input[type="text"][data-name],' +
		 							'input[type="number"][data-name],' +
									'input[type="password"][data-name],' +
									'textarea[data-name]';


	return toolkit.create('b-controls-group', {
		service: true,

		init: function (){
			this._iCtrlEvents();
			this._initDropdowns();
		},

		setElement: function (el){
			if (this.$el){
				this.$el.off('.' + this.uniqId);
				$(document).unbind('.'+this.uniqid);
			}

			toolkit['b-toolkit'].fn.setElement.call(this, el);
			this._iCtrlEvents();
			return	this;
		},

		_iCtrlEvents: function (){
			var key = this.uniqid + '.ctrl.events';

			if( !this.$el.data(key) ){

				this.$el
					.data(key, true)
					.on('tap' + '.' + this.uniqid, '[data-name]',  this._emitUIEvent.bind(this))
					.on('mousedown' + '.' + this.uniqid +' touchstart' + '.' + this.uniqid, '.b-dropdown',  this._initDropdownData.bind(this))
					.on('mousedown' + '.' + this.uniqid +' mouseup' + '.' + this.uniqid, '.b-toolbar__btn',  this._mouseActions.bind(this));

				this.$el
					.on('keyup' + '.' + this.uniqid + ' change' + '.' + this.uniqid, TEXTABLE_FIELD_SELECTOR, this._emitUIEvent.bind(this));

				$(document)
					.unbind('.'+this.uniqid, this._mouseActions.bind(this))
					.bind('mouseup' + '.' + this.uniqid, this._mouseActions.bind(this));

			}
		},

		delegateEvents: function(){
			toolkit['b-toolkit'].fn.delegateEvents.call(this);
			this._iCtrlEvents();
		},

		undelegateEvents: function(){
			toolkit['b-toolkit'].fn.undelegateEvents.call(this);
			this.$el
				.data(this.uniqid + '.ctrl.events', false);
		},


		_initDropdownData: function (evt){
			var $dd = $(evt.currentTarget), $list = $dd.find('.b-dropdown__list');

			if( !$list.is(':visible') ){
				var name  = $dd.attr('data-group');
				var items = this._getDropdownItems(name);

				if (Array.isArray(items)) {
					$list.fest(this.template, {
						  block: 'b-dropdown__list'
						, group: name
						, items: items
					})
				}
			}
		},

		_mouseActions: function(event) {
			if( event.button ) {
				//Если event.button != 0 - не левая кнопка мыши
				return;
			}


			var btn
				, currentBtn = null
				, down = event.type == "mousedown"
				, role
				, buttonsGroup = this
			;

			if( "mousedown mouseup".indexOf(event.type) !== -1) {
				if( event.currentTarget == document ) {
					if( this.__currentBtn ) {//Код для обычной кнопки
						btn = this.__currentBtn;
					}
				}
				else {
					btn = event.currentTarget;
				}

				if( btn ) {
					role = btn.getAttribute("role");
					if( role == "menuitemradio" ) {//Радио-кнопка
						if( event.type == "mouseup" ) {
							// Для радио-кнопок не обрабатываем mouseup
							btn = null;
						}
						else {
							btn = $(btn);
							buttonsGroup = btn.closest("[role=menubar],[role=menu]", this.$el);//this - toolbar

							toolkit.toggleMod(buttonsGroup.find(".b-toolbar__btn_active"), "active", false);
							btn = btn[0];
						}
					}
					else {
						// Если нажали на одной кнопке, а отпустили уже на другой
						if ( !down && btn !== this.__currentBtn) {
							toolkit.toggleMod( this.__currentBtn, "active", false );
						}

						//Текущюю "обычную" активную кнопку записываем в специальную переменную, для того, чтобы на mouseup у документа её перевести в обычное состояние
						currentBtn = btn;
					}

					if( btn && !btn.getAttribute("aria-disabled") ) {
						toolkit.toggleMod(btn, "active", down);

						buttonsGroup.__currentBtn = down && currentBtn || null;
					}

				}
			}
		},

		// @protected
		_getDropdownItems: function (name){
		},


		_getUIEvent: function (evt) {
			return toolkit['b-controls-group-utils'].fn._getUIEvent.apply(this, arguments);
		},

		_emitUIEvent: function (evt){
			toolkit['b-controls-group-utils'].fn._emitUIEvent.call(this, evt);
		},

		_initDropdowns: function() {
			this.$el.find('.b-dropdown').each(function (index, elem){
				new toolkit['b-dropdown']({ el: elem, scroll: this.scroll });
			}.bind(this));
		},

		render: function (data){
			// call parent method
			toolkit['b-toolkit'].fn.render.call(this, data);
			this._initDropdowns();
		},


		getItemElem: function (name){
			var $item = this.$el;

			name = name.split('.');

			if( name[1] ){
				$item = $item.find('[data-group="'+name.shift()+'"]');
			}

			$item = $item.find('[data-name="'+name[0]+'"]');
			if( !$item[0] ){
				$item = this.$el.find('[data-group="'+name[0]+'"]');
			}

			return	$item;
		},


		enable: function (){
			return	this.setDisabledState(false);
		},


		disable: function (){
			return	this.setDisabledState(true);
		},

		setDisabledState: function (state){
			this.$el && this.$el.children().each(function (i, node){
				toolkit.toggleMod($(node), 'disabled', state);
			}.bind(this));

			return	this;
		},


		setMod: function (name, mod, state){
			var $item = this.getItemElem(name);
			toolkit.toggleMod($item, mod, state);

			return	this;
		},

		destroy: function (ignoreChildren) {
			this.$el.off('.' + this.uniqId);
			toolkit['b-toolkit'].fn.destroy.apply(this, arguments);
			$(document).unbind('.'+this.uniqid);
		}
	});

});
